import React from "react";
import { motion } from "framer-motion";
import { TriangleAlertIcon, DownloadIcon } from "lucide-react";
import { CtaButton } from "../ui/CtaButton";
import { CountdownDisplay } from "../ui/CountdownDisplay";
import { StockBar } from "../ui/StockBar";
import { CheckoutTrust } from "../ui/CheckoutTrust";
import { useOffer } from "../../contexts/OfferContext";
import { CHECKOUT_URL, FUTURE_PRICE, PRICE_TODAY, TOTAL_VALUE } from "../../data/offer";
import { desserts, mockupUrl } from "../../data/images";
import { EASE_OUT } from "../../utils/motion";
export function PricingSection() {
  const {
    dateLabel,
    city
  } = useOffer();
  return <section id="precio" className="relative scroll-mt-24 overflow-hidden bg-cocoa-dark py-20 text-cream lg:py-28" data-id="element-346" data-mp="1u3usrgrku2oo">
      <img src={desserts.berryBar} alt="" aria-hidden className="absolute -left-20 top-16 hidden w-56 -rotate-12 rounded-3xl object-cover opacity-20 lg:block" data-id="element-347" data-mp="1p6w0z4vdy7tn" />
      <img src={desserts.popsicles} alt="" aria-hidden className="absolute -right-16 bottom-16 hidden w-56 rotate-12 rounded-3xl object-cover opacity-20 lg:block" data-id="element-348" data-mp="3jju85flsgocr" />

      <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 lg:grid-cols-[0.9fr_1.1fr]" data-id="element-349" data-mp="f3qmetuuzweo">
        <div className="text-center lg:text-left" data-id="element-350" data-mp="6q57kaanjug">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT
        }} className="mx-auto inline-flex items-center gap-2 rounded-full bg-leaf/15 px-4 py-2 text-sm font-semibold text-cream ring-1 ring-leaf/40 lg:mx-0" data-id="element-351" data-mp="81ajoje0zno">
            <span className="relative flex h-2.5 w-2.5" data-id="element-352" data-mp="j49fer8hn8ig">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#4ADE80] opacity-75" data-id="element-353" data-mp="o3dntfnl927q" />
              <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#4ADE80]" data-id="element-354" data-mp="1bsf23jj3r7kx" />
            </span>
            Oferta activa hoy: {dateLabel}
            {city ? ` · ${city}` : ""}
          </motion.div>

          <h2 className="mt-6 font-display text-4xl font-bold leading-tight sm:text-5xl" data-id="element-355" data-mp="1qfn885xk0mq1">
            Tu precio especial de <span className="text-gold-light" data-id="element-356" data-mp="1lhved6dcmqj7">lanzamiento</span>
          </h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.1,
          ease: EASE_OUT
        }} className="relative mx-auto mt-10 max-w-md lg:mx-0" data-id="element-357" data-mp="1he5s4nk5cl1c">
            <motion.img src={mockupUrl} alt="Pack Dulce Saludable completo" className="w-full rounded-[2rem] border-[10px] border-cream shadow-[0_40px_80px_-30px_rgba(0,0,0,0.8)]" animate={{
            y: [0, -8, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }} data-id="element-358" data-mp="12p1dthgh30yi" />
            <span className="absolute -bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2 whitespace-nowrap rounded-full bg-gold-light px-4 py-2 text-xs font-bold text-cocoa-dark shadow-lg sm:text-sm" data-id="element-359" data-mp="jr6vudxd9f3z">
              <DownloadIcon className="h-4 w-4" data-id="element-360" data-mp="30ddir7xzic2p" /> 100% digital · Descarga instantánea
            </span>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT
      }} className="relative rounded-[2rem] border border-gold/40 bg-cocoa p-6 shadow-[0_40px_100px_-30px_rgba(0,0,0,0.8)] sm:p-10" data-id="element-361" data-mp="35e1bby1v30z1">
          <motion.span initial={{
          opacity: 0,
          scale: 1.4,
          rotate: -20
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: -8
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.35,
          ease: EASE_OUT
        }} className="absolute -right-3 -top-5 rounded-xl bg-berry px-4 py-2 text-center font-display text-lg font-bold text-white shadow-xl sm:-right-6 sm:text-xl" data-id="element-362" data-mp="2loqu2fmgw7yt">
            95% DE DESCUENTO
          </motion.span>

          <div className="text-center" data-id="element-363" data-mp="19w8c7ixvj5a5">
            <p className="text-sm font-semibold uppercase tracking-widest text-cream/60" data-id="element-364" data-mp="19xay1cgcahj7">Valor de mercado</p>
            <p className="relative mx-auto mt-1 w-fit font-display text-3xl font-bold text-cream/50" data-id="element-365" data-mp="1omfil0alwxuh">
              ${TOTAL_VALUE}
              <motion.span aria-hidden className="absolute left-[-6%] top-1/2 h-[3px] w-[112%] origin-left -rotate-6 bg-berry" initial={{
              scaleX: 0
            }} whileInView={{
              scaleX: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: 0.2,
              ease: EASE_OUT
            }} data-id="element-366" data-mp="1jsbdynotd1wk" />
            </p>

            <p className="mt-6 text-sm font-bold uppercase tracking-widest text-gold-light" data-id="element-367" data-mp="22it20eypb9bl">Precio hoy</p>
            <motion.p initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: 0.25,
            ease: EASE_OUT
          }} className="font-display text-7xl font-bold leading-none text-gold-light sm:text-8xl" data-id="element-368" data-mp="d7k3xebymwdx">
              <span className="align-top text-4xl" data-id="element-369" data-mp="2a3dfya8h8jst">$</span>
              {PRICE_TODAY}
            </motion.p>
            <p className="mt-3 text-cream/75" data-id="element-370" data-mp="2f1opskyruub1">Pago único. Acceso inmediato a todos los materiales.</p>
          </div>

          <div className="mt-8" data-id="element-371" data-mp="215kxix7gkw17">
            <p className="mb-4 text-center text-sm font-semibold text-cream/70" data-id="element-372" data-mp="254tnrs3aibs0">El descuento termina en:</p>
            <CountdownDisplay data-id="element-373" data-mp="1r5u0anrik2xf" />
          </div>

          <p className="mt-6 flex items-start gap-2 rounded-xl border border-berry/50 bg-berry/15 p-3 text-sm text-cream" data-id="element-374" data-mp="1r754upss9epl">
            <TriangleAlertIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#FF8FA8]" data-id="element-375" data-mp="3ljbtorelnu0d" />
            El precio subirá a ${FUTURE_PRICE} en cuanto el contador llegue a cero.
          </p>

          <div className="mt-4" data-id="element-376" data-mp="3qgby6xvswopd">
            <StockBar data-id="element-377" data-mp="3p0zfo5cy3w0z" />
          </div>

          <div className="mt-6" data-id="element-378" data-mp="3p2u4vvv92aav">
            <CtaButton href={CHECKOUT_URL} label="Sí, quiero mi Pack Dulce Saludable" sublabel={`Acceso inmediato por $${PRICE_TODAY}`} data-id="element-379" data-mp="3oywk75t0xaov" />
          </div>

          <CheckoutTrust tone="dark" data-id="element-380" data-mp="3f3uti5j3o0k6" />
        </motion.div>
      </div>
    </section>;
}